import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "absolute inset-0 flex items-center",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "relative flex justify-center" }


	const __default__ = { name: 'VDividerLabel' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		// matches the surface behind the divider so the label sits in a gap in the line
		backgroundClassName: {
			type: String,
			default: 'bg-white'
		},
		className: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		soft: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	// eslint-disable-next-line
	const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.className, "relative"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_divider, { soft: __props.soft }, null, 8, ["soft"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass([__props.backgroundClassName, "px-3 text-sm text-gray-500 dark:text-gray-400"])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.label), 1)
        ])
      ], 2)
    ])
  ], 2))
}
}

})